import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Card = styled.div`
  ${tw`w-full h-full rounded-lg flex flex-col overflow-hidden border border-gray-300`};
`;
